import React, {memo} from "react";

const Footer = () => (
    <footer className={`py-12 text-white bg-blue-800 flex flex-wrap justify-center gap-5 md:justify-between items-center md:px-32`}>
        <p className={`text-xl my-3`}>Copyright 2022 &copy; Omar Khaled</p>
        <p className={`text-xl`}>Omar Khaled Portfolio</p>
    </footer>
)
export default memo(Footer)